<router-outlet></router-outlet>

<div id="boot-content" class="container">
  <div class="logobg"><span></span></div>
</div>
<ng-container *ngTemplateOutlet="modalwaitTemplate; context: {$implicit: modalState$ | async}"></ng-container>

<ng-template #modalwaitTemplate let-modalState>
  @if (modalState?.show) {
    <div class="modalwait" [@fadeInOut]>
      <div class="background"></div>
      <div class="cs-loader">
        <div class="loadinglogo"></div>
        <span>{{ modalState.text }}</span>
        @if (modalState.showProgress && modalState.progress >= 0) {
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="modalState.progress">{{modalState.progress + '%'}}</div>
          </div>
        }
        @if (modalState.showProgress === false) {
          <div class="cs-loader-inner">
            <label> ●</label>
            <label> ●</label>
            <label> ●</label>
            <label> ●</label>
            <label> ●</label>
            <label> ●</label>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
